/** @flow */
import UserProfileAPI from 'common/modules/userProfile/services/UserProfileAPI';
import RadioUser from '../../../domain/RadioUser';
import type { Dispatch, GetState } from '../../../types/Store';
import { getToken } from '../../authentication/session/reducers/sessionReducer';
import { updateRadioUser } from '../../authentication/session/actions/sessionActions';
import { getRadioUser } from '../../authentication/session/selectors/sessionSelectors';

export const FETCH_PROFILE = 'userProfile/FETCH_PROFILE';
export const FETCH_PROFILE_SUCCESS = 'userProfile/FETCH_PROFILE_SUCCESS';
export const FETCH_PROFILE_FAILURE = 'userProfile/FETCH_PROFILE_FAILURE';

export const UPDATE_PROFILE = 'userProfile/UPDATE_PROFILE';
export const UPDATE_PROFILE_SUCCESS = 'userProfile/UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_FAILURE = 'userProfile/UPDATE_PROFILE_FAILURE';

export const UPDATE_PASSWORD = 'userProfile/UPDATE_PASSWORD';
export const UPDATE_PASSWORD_SUCCESS = 'userProfile/UPDATE_PASSWORD_SUCCESS';
export const UPDATE_PASSWORD_FAILURE = 'userProfile/UPDATE_PASSWORD_FAILURE';

export const UPDATE_EMAIL = 'userProfile/UPDATE_EMAIL';
export const UPDATE_EMAIL_SUCCESS = 'userProfile/UPDATE_EMAIL_SUCCESS';
export const UPDATE_EMAIL_FAILURE = 'userProfile/UPDATE_EMAIL_FAILURE';

export const CONFIRM_EMAIL = 'userProfile/CONFIRM_EMAIL';
export const CONFIRM_EMAIL_SUCCESS = 'userProfile/CONFIRM_EMAIL_SUCCESS';
export const CONFIRM_EMAIL_FAILURE = 'userProfile/CONFIRM_EMAIL_FAILURE';

export function fetchProfile() {
  return async (dispatch: Dispatch, getState: GetState) => {
    dispatch({ type: FETCH_PROFILE });

    try {
      const token = getToken(getState());
      const data = await UserProfileAPI.fetchProfile(token);

      dispatch({ type: FETCH_PROFILE_SUCCESS, userProfile: data.profile, userEmail: data.email });
    } catch (error) {
      dispatch({ type: FETCH_PROFILE_FAILURE, error: error });
    }
  };
}

export function updateProfile(userProfile: Object) {
  return async (dispatch: Dispatch, getState: GetState) => {
    dispatch({ type: UPDATE_PROFILE });

    try {
      const state = getState();
      const token = getToken(state);
      await UserProfileAPI.updateProfile(token, userProfile);

      // TODO - Enlever le parse lorsqu'on aura immutable parce qu'actuellement updateUserProfile modifie pas la ref. du RadioUser
      let radioUser = getRadioUser(state);
      radioUser.setUserProfile(userProfile);
      radioUser = RadioUser.parse(radioUser);

      dispatch({ type: UPDATE_PROFILE_SUCCESS, userProfile: userProfile });
      dispatch(updateRadioUser(radioUser));
    } catch (error) {
      dispatch({ type: UPDATE_PROFILE_FAILURE, error: error });
    }
  };
}

export function updatePassword(passwords: Object) {
  return async (dispatch: Dispatch, getState: GetState) => {
    dispatch({ type: UPDATE_PASSWORD });

    try {
      const token = getToken(getState());
      await UserProfileAPI.updatePassword(token, passwords);

      dispatch({ type: UPDATE_PASSWORD_SUCCESS });
    } catch (error) {
      dispatch({ type: UPDATE_PASSWORD_FAILURE, error: error });
    }
  };
}

export function updateEmail(emails: Object) {
  return async (dispatch: Dispatch, getState: GetState) => {
    dispatch({ type: UPDATE_EMAIL });

    try {
      const state = getState();
      const token = getToken(state);
      await UserProfileAPI.updateEmail(token, emails);

      dispatch({ type: UPDATE_EMAIL_SUCCESS });
    } catch (error) {
      dispatch({ type: UPDATE_EMAIL_FAILURE, error: error });
    }
  };
}

export function confirmEmail(token: string) {
  return async (dispatch: Dispatch, getState: GetState) => {
    dispatch({ type: CONFIRM_EMAIL });

    try {
      await UserProfileAPI.confirmEmail(token);

      dispatch({ type: CONFIRM_EMAIL_SUCCESS });
    } catch (error) {
      dispatch({ type: CONFIRM_EMAIL_FAILURE, error: error });
    }
  };
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/userProfile/actions/userProfileActions.js